import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const GiftSelectModalLazy = React.lazy(() =>
  import('./GiftSelectModal').then((m) => ({ default: m.GiftSelectModal })),
);
type GiftSelectModalProps = React.ComponentProps<typeof import('./GiftSelectModal').GiftSelectModal>;

NiceModal.register(
  MODALS.GIFT_SELECT,
  NiceModal.create((props: GiftSelectModalProps) => (
    <Suspense fallback={null}>
      <GiftSelectModalLazy {...props} />
    </Suspense>
  )),
);
